import { render, staticRenderFns } from "./coalAuxiliaryComponent.vue?vue&type=template&id=98ac6e24&"
import script from "./coalAuxiliaryComponent.vue?vue&type=script&lang=js&"
export * from "./coalAuxiliaryComponent.vue?vue&type=script&lang=js&"
import style0 from "./coalAuxiliaryComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports